export default __webpack_public_path__ + "static/media/closet5-after3-1024w.550de8ab.avif";